import { render, staticRenderFns } from "./NoConnection.vue?vue&type=template&id=a54f51fe&"
import script from "./NoConnection.vue?vue&type=script&lang=js&"
export * from "./NoConnection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports